import React from 'react';

import { useAppContext } from 'src/components/app-context';
import { BodyMediumText } from '@prisjakt/ui/text/variants';

import { StyledNoResult, StyledTitle, StyledImage } from './styles';

type Props = {
  title: string;
  content?: React.ReactElement | false;
};

export const NoResults = (props: Props) => {
  const { content, title } = props;
  const { market, t } = useAppContext();

  return (
    <StyledNoResult gap={1}>
      <BodyMediumText>
        <StyledTitle>{title}</StyledTitle>
        {content}
      </BodyMediumText>

      <div>
        <StyledImage
          src={`${market.cdn}/g/rfe/illustrations/no-search-result-illustration-309x229px.png`}
          srcSet={`${market.cdn}/g/rfe/illustrations/no-search-result-illustration-309x229px.png 1x, ${market.cdn}/g/rfe/illustrations/no-search-result-illustration-618x458px.png 2x`}
          alt={t('product', 'results.no-product-found')}
        />
      </div>
    </StyledNoResult>
  );
};
